import React, { useContext, useState } from "react";
import { ApiRoutes, FetchContext, HttpMethods } from '../contexts';

export const ApiContext = React.createContext(null);

const { Provider } = ApiContext;
export const ApiProvider = ({ ...props }) => {

    // providers
    const { fetchAuthorized } = useContext(FetchContext);

    const [isLoadingUtenti, setIsLoadingUtenti] = useState(false);
    const getUtentiAsync = async (pageIndex = 0, pageSize = 1000, term) => {
        try {
            setIsLoadingUtenti(true);
            const r = await fetchAuthorized(ApiRoutes.Utente.GetUtenti({ pageIndex, pageSize, term }), {
                method: HttpMethods.GET
            });
            const response = await r.json();

            response.result.forEach(x => {
                x.inizioValidita = new Date(x.inizioValidita);
                x.fineValidita = x.fineValidita ? new Date(x.fineValidita) : null;
            });

            return { data: response };
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingUtenti(false);
        }
    }

    const [isLoadingImpostazione, setIsLoadingImpostazione] = useState(false);
    const getImpostazioneAsync = async () => {
        try {
            setIsLoadingImpostazione(true);
            const r = await fetchAuthorized(ApiRoutes.Impostazione.GetImpostazione(), {
                method: HttpMethods.GET
            });
            const response = await r.json();
            return { data: response };
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingImpostazione(false);
        }
    }

    return (
        <Provider value={{

            isLoadingUtenti,
            getUtentiAsync,

            isLoadingImpostazione,
            getImpostazioneAsync,

        }}>
            {props.children}
        </Provider>
    );
}